import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import theme from "../../theme";
import mq from "../../utils/mediaQuery";
import { ListItem } from "../List";

const TitleWrapper = styled.div`
  margin-bottom: ${theme.space("xs")};
`;

const MethodsWrapper = styled.div`
  ${mq("2")} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: ${theme.space("xxs")};
    grid-column-gap: ${theme.space("l")};
  }

  ${mq("3")} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

function Methods({ methods, title, ...props }) {
  return (
    <div {...props}>
      <TitleWrapper>{title}</TitleWrapper>
      <MethodsWrapper>
        {methods.map(({ id, name }) => (
          <ListItem bulleted={true} key={id}>
            {name}
          </ListItem>
        ))}
      </MethodsWrapper>
    </div>
  );
}

export const methodItem = {
  name: PropTypes.string.isRequired,
};

Methods.propTypes = {
  title: PropTypes.node.isRequired,
  methods: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      ...methodItem,
    })
  ).isRequired,
};

export default Methods;
